var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"px-2.5 right-11",class:_vm.highlight ? 'bg-opacity-70' : 'bg-opacity-40',staticStyle:{"max-width":"calc(100% - 52px)"},attrs:{"href":_vm.url,"title":_vm.title}},[_c('span',{staticClass:"inline-block w-full truncate"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }